import React from 'react';
import { useStravaTranslations } from '@strava/container-context';
import clsx from '@strava/ui/clsx';
import styles from './MobileRegistrationMessage.module.scss';

interface MobileRegistrationMessageProps {
  className?: string;
}

export const MobileRegistrationMessage = ({
  className
}: MobileRegistrationMessageProps) => {
  const i18nPrefix = 'account_registration_page_ui';
  const { t } = useStravaTranslations();

  return (
    <div className={clsx(styles.mobileRegistrationMessage, className)}>
      <h1>{t(`${i18nPrefix}.mobile.title`)}</h1>
      <p>{t(`${i18nPrefix}.mobile.subtitle`)}</p>
    </div>
  );
};

export default MobileRegistrationMessage;
